import { Button, Form, Input } from "antd";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import _t from "../../../../lang/translate";
import { TimelineItemProps } from "./timelineItems";

export default function Note({ event, editing, cancelEditing }: TimelineItemProps<"note_added"|"message_added">) {
  function submit(values: { note: string }) {
    try {
      // const ff = await patchEntityRecording(event.id, {
      //
      // })
      // const newTimeline = timeline?.map(item => {
      //   if (item.id !== event.id) return item;
      //   return {
      //     ...item,
      //     type: "NOTE",
      //     data: {
      //       ...item.data,
      //       note: values.note
      //     }
      //   }
      // })
      // setTimeline(newTimeline ?? [])
      cancelEditing && cancelEditing()
    } catch (error) {
      renderErrorMessage(error)
    } finally {

    }
  }

  return (
    <div>
      {editing ? (
        <Form onFinish={submit} initialValues={{ note: event.payload?.content }}>
          <Form.Item name="note" className='mb-0'>
            <Input.TextArea autoSize={{ minRows: 5 }} />
          </Form.Item>
          <div className='text-right mt-05'>
            <Button size="small" onClick={cancelEditing} className="mr-05">{_t("cancel")}</Button>
            <Button size="small" type='primary' htmlType='submit'>{_t("save")}</Button>
          </div>
        </Form>
      ) : (
        <div style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}>{event.payload?.content}</div>
      )}
    </div>
  )
}
